<!-- src/components/LoginForm.vue -->
<template>
<div>
  <div class="form-container">
  <form @submit.prevent="login" class="login-form">
    <h2>Login</h2>
    <img src="https://ztchecvzbsazdgbkuzzp.supabase.co/storage/v1/object/public/media-storage-bucket/mountain.jpg" alt="Logo" class="logo" @click="navigateToHome" />
   


    <input type="email" placeholder="Email" v-model="email" required />
    <!-- <input type="password" placeholder="Password" v-model="password" required /> -->
    <input v-if="verify" placeholder="Enter OTP" v-model="token" required />

    <button v-if="!verify" class="submit-button" type="submit">Login</button>
    <button v-if="verify" @click="verifyOtp" class="submit-button" >Verify OTP</button>

  </form>
</div>
</div>

</template>




<script>

import { supabase } from '@/supabase.js'
// import { useAuthStore } from '@/stores/authStores';
// import {ref} from 'vue';
// import { useRouter } from 'vue-router';
import { _store } from '@/stores/userStore';



export default {

  data() {
    return {
      email: '',
      messa:false,
      verify:false,
      store:_store,
      token:null,
    };
  },

// setup() {
//     const emailo = ref('');
//     const passwordo = ref('');
//     const authStore = useAuthStore();
//     const router = useRouter();

//     const sgnin = async () => {
//       try {
//         await authStore.signin(emailo.value, passwordo.value);
//         router.push(`/`)

//       } catch (error) {
//         console.error(error.message);
//       }
//     }
//     return{sgnin,emailo,passwordo}
// },



  methods: {
    async login() {
      try {
        // const { user, session, error } = await supabase.auth.signInWithPassword({
        //   email: this.email,
        //   password: this.password,
        // });

        const { data, error } = await supabase.auth.signInWithOtp({
          email: this.email,
          options: {
            // set this to false if you do not want the user to be automatically signed up
            shouldCreateUser: false,
          },
        })

        if (error) {
          console.error(error);
        } else {
          console.log('User:', data);
          // console.log('Session:', session);
          this.messa=true
          this.store.fetchUser();
          this.verify=true
        }
      } catch (error) {
        console.error('Error:', error.message);
      }
      
    },
     async verifyOtp() {
      try {
          const {
            data: { session },
            error,
          } = await supabase.auth.verifyOtp({
            email: this.email,
            token: this.token,
            type: 'email',
          })       

     

        if (error) {
          console.error(error);
        } else {
          console.log('Session:', session);
          this.messa=true
          this.store.fetchUser();
          this.$router.push(`/`);

        }
      } catch (error) {
        console.error('Error:', error.message);
      }
      
    }
  },

};

</script>


<style scoped>
.login-form {
  display: flex;
  flex-direction: column;
  width: 350px;
  /* margin: 2% auto 0; */
  margin: auto 0;
  gap: 5%;
  border: 1px solid grey;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  background: #1a1625;
  align-items: center;
  justify-content: center;
}

.form-container{
  height:100vh;
  width:100vw;
  /* border-top:30px solid transparent; */
  display: flex;
  justify-content: center;
  background: #2f2b3a ;
}


h2 {
  text-align: center;
  color: peachpuff;
}

label {
  /* display: block; */
  margin-bottom: 8px;
  color: #555;
}

input {
  width: 80%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid grey;
  border-radius: 4px;
  text-align: center;
  background: #2f2b3a ;
  color: white;
}

p{
  text-align: left;
  color:whitesmoke;
  font-size: 15px;
}

.signup{
  text-align: center;
  color:grey;
  font-size: 15px;
}

.google-button,.facebook-button,.apple-button,.submit-button {
  width: 80%;
  padding: 12px;
  margin-top:8px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ddd;
  transition: background-color 0.3s;
  text-align: center;
}

.google-button{
  background: #2f2b3a ;
  color:whitesmoke;
  
}

.facebook-button{
  background-color: White;
  color: rgb(89, 86, 86);

}

.apple-button{
  background: #2f2b3a ;
  color:whitesmoke;
}

.submit-button{
  width:86%;
  background-color: #ffff99;
  color: #001233;
  border: 1px solid #8f9ba3;
  font-size: 14px;
  margin-bottom: 20px;
  margin-top: 20px;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
}


.submit-button:hover {
  background-color: #d5d58b;
}

.google-icon{
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
}

.logo {
  width: 70px;
  height: 70px;
  cursor: pointer;
  border-radius: 50%;
}

.hyper-link{
  color:cyan;
}

</style>
